import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import {
    FaFilePdf,
    FaPrint,
    FaFileExcel,
    FaCopy,
    FaSearch,
    FaArrowLeft
} from 'react-icons/fa';

const ViewDDRPatrak = () => {
    const [ddrData, setDdrData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        const ddrRef = ref(db, 'ekamwatapzp/SocietyDDRPatrak');
        const unsubData = onValue(ddrRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data).map(key => ({
                    dbKey: key,
                    ...data[key]
                }));
                // Sort by submittedAt descending
                list.sort((a, b) => (b.submittedAt || 0) - (a.submittedAt || 0));
                setDdrData(list);
            }
            setLoading(false);
        });

        return () => {
            unsubscribe();
            unsubData();
        };
    }, [navigate]);

    const filteredData = ddrData.filter(item => {
        const name = (item.societyName || '').toLowerCase();
        const outgoing = (item.outgoingNo || '').toString().toLowerCase();
        const search = searchTerm.toLowerCase();
        return name.includes(search) || outgoing.includes(search);
    });

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-gray-50 flex flex-col">
                {/* Header Section */}
                <div className="bg-white border-b border-gray-200 px-6 py-4 flex flex-col md:flex-row md:items-center justify-between gap-4 shadow-sm">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="p-2.5 bg-white border border-gray-200 rounded-xl text-gray-400 hover:text-blue-600 hover:border-blue-100 hover:bg-blue-50 transition-all shadow-sm group"
                        >
                            <FaArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
                        </button>
                        <h1 className="text-xl font-bold text-gray-800 tracking-tight">View Upload DDR Patrak</h1>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                        <span>Zilla Parishad</span>
                        <span className="text-gray-400">/</span>
                        <span className="font-medium text-gray-600">View Upload DDR Patrak</span>
                    </div>
                </div>

                <div className="p-4 md:p-8">
                    <div className="max-w-7xl mx-auto bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden p-6 md:p-8">

                        {/* Action Buttons & Search */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                            <div className="flex items-center gap-0.5">
                                <button className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 text-sm font-medium transition-colors first:rounded-l-md">
                                    Copy
                                </button>
                                <button className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 text-sm font-medium transition-colors">
                                    Excel
                                </button>
                                <button className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 text-sm font-medium transition-colors last:rounded-r-md border-l border-gray-500">
                                    Print
                                </button>
                            </div>

                            <div className="flex items-center gap-2">
                                <label className="text-sm font-medium text-gray-600">Search:</label>
                                <div className="relative">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="border border-gray-300 rounded-md px-3 py-1.5 text-sm outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all w-48 md:w-64"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto border border-gray-100 rounded-lg">
                            <table className="w-full text-left text-sm">
                                <thead>
                                    <tr className="bg-gray-50 text-gray-700 border-b border-gray-200">
                                        <th className="px-5 py-4 font-bold border-r border-gray-200 w-16 text-center">#</th>
                                        <th className="px-5 py-4 font-bold border-r border-gray-200">ID</th>
                                        <th className="px-5 py-4 font-bold border-r border-gray-200">Institution Name</th>
                                        <th className="px-5 py-4 font-bold border-r border-gray-200">Outgoing No.</th>
                                        <th className="px-5 py-4 font-bold border-r border-gray-200">Tipani Date</th>
                                        <th className="px-5 py-4 font-bold border-r border-gray-200 text-center">DDR File</th>
                                        <th className="px-5 py-4 font-bold text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {loading ? (
                                        <tr>
                                            <td colSpan="7" className="px-6 py-10 text-center text-gray-400 italic">लोड होत आहे...</td>
                                        </tr>
                                    ) : filteredData.length > 0 ? (
                                        filteredData.map((item, index) => (
                                            <tr key={item.dbKey} className="hover:bg-gray-50/80 transition-colors">
                                                <td className="px-5 py-4 border-r border-gray-100 text-center text-gray-600 font-medium">
                                                    {index + 1}
                                                </td>
                                                <td className="px-5 py-4 border-r border-gray-100 text-gray-700">
                                                    {index + 1}
                                                </td>
                                                <td className="px-5 py-4 border-r border-gray-100 font-medium text-gray-800">
                                                    {item.societyName}
                                                </td>
                                                <td className="px-5 py-4 border-r border-gray-100 text-gray-600">
                                                    {item.outgoingNo}
                                                </td>
                                                <td className="px-5 py-4 border-r border-gray-100 text-gray-600">
                                                    {item.tipaniDate}
                                                </td>
                                                <td className="px-5 py-4 border-r border-gray-100 text-center">
                                                    {item.fileUrl && (
                                                        <a
                                                            href={item.fileUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="inline-flex items-center justify-center p-2 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 transition-colors shadow-sm"
                                                            title="View PDF"
                                                        >
                                                            <FaFilePdf size={18} />
                                                        </a>
                                                    )}
                                                </td>
                                                <td className="px-5 py-4">
                                                    <div className="flex items-center justify-center gap-3">
                                                        <button
                                                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                                            title="Print Tipani"
                                                            onClick={() => window.print()}
                                                        >
                                                            <FaPrint size={16} />
                                                        </button>
                                                        <button
                                                            className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors border border-gray-200 shadow-sm"
                                                            title="Print Details"
                                                            onClick={() => window.print()}
                                                        >
                                                            <FaPrint size={16} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="px-6 py-12 text-center text-gray-400 font-medium">
                                                कोणताही डेटा सापडला नाही.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination Footer */}
                        <div className="mt-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
                            <p className="text-sm text-gray-500">
                                Showing {filteredData.length > 0 ? 1 : 0} to {filteredData.length} of {filteredData.length} entries
                            </p>
                            <div className="flex items-center">
                                <button disabled className="px-4 py-2 text-sm text-gray-400 font-medium cursor-not-allowed">
                                    Previous
                                </button>
                                <button className="w-9 h-9 flex items-center justify-center bg-[#5c69e5] text-white rounded text-sm font-bold shadow-md shadow-blue-100">
                                    1
                                </button>
                                <button disabled className="px-4 py-2 text-sm text-gray-400 font-medium cursor-not-allowed font-medium">
                                    Next
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </InchargeLayout>
    );
};

export default ViewDDRPatrak;
